import { render, staticRenderFns } from "./TodaySouthAmount.vue?vue&type=template&id=bcd2e164"
import script from "./TodaySouthAmount.vue?vue&type=script&lang=js"
export * from "./TodaySouthAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports